import React, { Component } from "react";
import { connect } from "react-redux";

import { ChatIcon, ScreenShareIcon, MagnifyIcon } from "./utils/components/icons";

class SitecontactDetails extends Component {

  toogleContactVisible = (event) => {
    const body = document.querySelector('body');
    if (!body || !body.classList) return;
    if (event.code && event.code !== 'Space') return;
    body.classList.toggle("contact_visible");
  };

  componentDidMount = () => {
    document.querySelectorAll('.if6_contact>span').forEach(span => {
      span.addEventListener('click', this.toogleContactVisible);
      span.addEventListener('keyDown', this.toogleContactVisible);
    });

  };

  componentWillUnmount = () => {
    document.querySelectorAll('.if6_contact>span').forEach(span => {
      span.removeEventListener('click', this.toogleContactVisible);
      span.removeEventListener('keyDown', this.toogleContactVisible);
    });
  };

  render() {
    if (!this.props.configStorage.hasMenu()) return null;
    let contactDetails = this.props.mandantStorage.contactDetails;
    //let imageUrl = this.props.configStorage.getContactImageUrl();
    return (
      <section aria-label="Kontaktbereich">
        <div className="if6_contact">
          <button title="Kontaktbereich"
            aria-label="Öffnet den Kontaktbereich der Seite"
            onClick={this.toogleContactVisible}
            onKeyDown={this.toogleContactVisible}
          >
            <span className="icon-telefon" title="Icon Telefon" />
            <span className="icon-chat" title="Icon Chat" />
            <span className="icon-mail" title="Icon Email" />
          </button>
          <div>
            <div className="contactiparsys">
              <div className="section">
                <div className="new"></div>
              </div>
              <div className="iparys_inherited">
                <div className="iparsys contactiparsys parsys bootstrap-iso">
                  <div className="c_block section">
                    <samp className="vis always"></samp>
                    <h3 aria-level="2">Kontakt</h3>
                    <br />
                    {this.props.configStorage.getMandantLogo() &&
                      <img
                        className="small-image"
                        src={this.props.configStorage.getContactImageUrl()}
                        alt=""
                      />
                    }
                    <div className="VR-Kontakt">
                      <div className={"section special c_button" + (contactDetails.telefon === "" ? " d-none" : "")}>
                        <svg
                          viewBox="0 0 40 40"
                          id="icon-line-call"
                          className="icon-call"
                        >
                          <title>Telefonnummer</title>
                          <path d="M30.09 3c.59.05 5.56.63 6.89 5.42-.32 1-2.59 3.3-4.69 4.46-.77.43-1.24.55-1.48.59-.08-.1-.18-.21-.29-.35-1.62-1.97-2.49-2.87-3.21-3.34 0 0-.58-.51-1.93-.47-2.15.07-5.23 2.59-9.23 6.56l-.14.13-.14.14c-3.99 4.02-6.52 7.18-6.55 9.27-.02 1.1.42 1.8.42 1.8.36.6 1.06 1.44 3.67 3.51.08.06.15.12.2.16 0 .28-.18 1.08-1.04 2.36-.44.65-1.09 1.43-1.74 2.08-1.11 1.11-1.88 1.53-2.17 1.64-4.45-2.07-5.5-6.21-5.66-6.98.11-3.73 5.57-12.27 10.09-16.8l.04-.04C17.68 8.59 26.37 3.05 30.09 3m.04-3c-5.02 0-14.5 6.4-19.12 11C6.38 15.63-.05 25.15 0 30.15l.01.17c.04.27 1.12 6.64 7.7 9.51.27.12.56.17.85.17 1.4 0 3.04-1.2 4.39-2.54.88-.88 1.63-1.82 2.11-2.53 1.78-2.64 2.04-4.81.74-6.11-.13-.13-.31-.27-.53-.45-2.15-1.7-2.78-2.41-2.95-2.69.16-1.88 4.12-5.82 5.83-7.55 1.71-1.69 5.64-5.63 7.53-5.82.61.39 2.04 2.14 2.53 2.73.3.37.53.64.64.75.38.38.96.71 1.82.71.77 0 1.77-.26 3.07-.98 2.56-1.42 6.82-5.18 6.2-7.62C38.46 2 32.95.16 30.19.01 30.17 0 30.15 0 30.13 0z"></path>
                        </svg>
                        <span id="tel">
                          {contactDetails.telefon}
                          <br />
                        </span>
                      </div>
                      <div className={"section special c_button" + (contactDetails.mail === "" ? " d-none" : "")}>
                        <svg
                          viewBox="0 0 40 40"
                          id="icon-line-mail"
                          className="icon-call"
                        >
                          <title>Email</title>
                          <path d="M24.6 25.2h-.1C23.2 29 20.9 31 17.3 31c-2.1.1-4.1-.8-5.5-2.5-1.5-1.9-2.2-4.2-2.1-6.6-.1-3.3.9-6.5 2.9-9.1 1.7-2.3 4.5-3.7 7.5-3.6 1.1 0 2.2.3 3.2.9.9.5 1.5 1.3 1.8 2.3h.1c0-.5.1-1.4.2-2.8h3.1c-.8 8.9-1.2 13.5-1.2 13.7 0 3.4 1 5 2.9 5 1.8 0 3.3-.9 4.4-2.8 1.3-2.3 1.9-4.8 1.8-7.4.2-4.1-1.4-8-4.3-10.9C29.2 4.4 25.3 3 20.2 3c-4.6-.1-9 1.7-12.1 5.1-3.2 3.4-5 8-4.8 12.7 0 5 1.5 9 4.6 12.1s7.1 4.6 12.3 4.6c3.6.1 7.2-.6 10.4-2v3c-3.4 1.3-7 1.9-10.7 1.8-6 0-10.8-1.8-14.5-5.3C1.8 31.1 0 26.4 0 20.7-.2 15.2 1.9 9.9 5.8 5.9 9.6 2 15-.2 20.5 0c5.1-.2 10.1 1.6 13.9 4.9 3.7 3.3 5.7 8 5.5 12.8.1 3.4-.9 6.7-2.9 9.5-1.5 2.4-4.2 3.8-7 3.8-3.6 0-5.4-2-5.4-5.8zm-4.5-13.3c-2.1 0-4 1.1-5 2.9-1.3 2.1-2 4.6-1.9 7.1-.1 1.6.4 3.2 1.3 4.5.8 1.1 2.1 1.7 3.4 1.7 2.1 0 4-1.2 4.9-3 1.3-2.5 1.9-5.2 1.8-8 0-3.4-1.5-5.2-4.5-5.2z"></path>
                        </svg>
                        <span>
                          <a
                            itemProp="email"
                            href={contactDetails.mail}
                            target="_blank"
                            rel="noopener noreferrer"
                            title="Schreiben Sie uns"
                          >
                            {contactDetails.mailTitle}
                          </a>
                          <br />
                        </span>
                      </div>
                      <div className={"section special c_button" + (contactDetails.rueckruf === "" ? " d-none" : "")}>
                        <svg
                          viewBox="0 0 40 40"
                          id="icon-line-callback"
                          className="icon-call"
                        >
                          <title>Rückruf</title>
                          <path d="M28 36l-6.5-5.972L28 24v12zm10-8a2 2 0 11.001 3.999A2 2 0 0138 28zm-6 0a2 2 0 11.001 3.999A2 2 0 0132 28zM30.09 3c.59.05 5.56.63 6.89 5.42-.32 1-2.59 3.3-4.69 4.46-.77.43-1.24.55-1.48.59-.08-.1-.18-.21-.29-.35-1.62-1.97-2.49-2.87-3.21-3.34 0 0-.58-.51-1.93-.47-2.15.07-5.23 2.59-9.23 6.56l-.14.13-.14.14c-3.99 4.02-6.52 7.18-6.55 9.27-.02 1.1.42 1.8.42 1.8.36.6 1.06 1.44 3.67 3.51.08.06.15.12.2.16 0 .28-.18 1.08-1.04 2.36-.44.65-1.09 1.43-1.74 2.08-1.11 1.11-1.88 1.53-2.17 1.64-4.45-2.07-5.5-6.21-5.66-6.98.11-3.73 5.57-12.27 10.09-16.8l.04-.04C17.68 8.59 26.37 3.05 30.09 3m.04-3c-5.02 0-14.5 6.4-19.12 11C6.38 15.63-.05 25.15 0 30.15l.01.17c.04.27 1.12 6.64 7.7 9.51.27.12.56.17.85.17 1.4 0 3.04-1.2 4.39-2.54.88-.88 1.63-1.82 2.11-2.53 1.78-2.64 2.04-4.81.74-6.11-.13-.13-.31-.27-.53-.45-2.15-1.7-2.78-2.41-2.95-2.69.16-1.88 4.12-5.82 5.83-7.55 1.71-1.69 5.64-5.63 7.53-5.82.61.39 2.04 2.14 2.53 2.73.3.37.53.64.64.75.38.38.96.71 1.82.71.77 0 1.77-.26 3.07-.98 2.56-1.42 6.82-5.18 6.2-7.62C38.46 2 32.95.16 30.19.01 30.17 0 30.15 0 30.13 0z"></path>
                        </svg>
                        <span>
                          <a
                            itemProp="url"
                            href={contactDetails.rueckruf}
                            className="module-contact__value"
                            title="Rückruf"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {contactDetails.rueckrufTitle}
                          </a>
                          <br />
                        </span>
                      </div>
                      <div className={"section special c_button" + (contactDetails.terminLink === "" ? " d-none" : "")}>
                        <svg
                          viewBox="0 0 40 40"
                          id="icon-line-appointment"
                          className="icon-call"
                        >
                          <title>Termin</title>
                          <path d="M31 21H20V8.25a1.5 1.5 0 00-3 0V22a2.179 2.179 0 002 2h12c1.736 0 1.625-3 0-3z"></path>
                          <path d="M20 3c9.374 0 17 7.626 17 17s-7.626 17-17 17S3 29.374 3 20 10.626 3 20 3m0-3C8.954 0 0 8.954 0 20s8.954 20 20 20 20-8.954 20-20S31.046 0 20 0z"></path>
                        </svg>
                        <span>
                          <a
                            itemProp="url"
                            href={contactDetails.terminLink}
                            className=""
                            target="_blank"
                            rel="noopener noreferrer"
                            title="Termin"
                          >
                            {contactDetails.terminLinkTitle}
                          </a>
                          <br />
                        </span>
                      </div>
                      <div className={"section special c_button" + (contactDetails.chat === "" ? " d-none" : "")}>
                        <ChatIcon aria-hidden="false">
                          <title>Chat</title>
                        </ChatIcon>
                        <span>
                          <a
                            href={contactDetails.chat}
                            title="Jetzt Chat starten"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {contactDetails.chatTitle}
                          </a>
                          <br />
                        </span>
                      </div>
                      <div className={"section special c_button" + (contactDetails.bildschirmteilen === "" ? " d-none" : "")}>
                        <ScreenShareIcon aria-hidden="false">
                          <title>Bildschirm teilen</title>
                        </ScreenShareIcon>
                        <span>
                          <a
                            href={contactDetails.bildschirmteilen}
                            title="Jetzt Co-Browsing starten"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {contactDetails.bildschirmteilenTitle}
                          </a>
                          <br />
                        </span>
                      </div>
                      <div className={"section special c_button" + (contactDetails.kontaktdaten === "" ? " d-none" : "")}>
                        <MagnifyIcon className="save-contact" aria-hidden="false">
                          <title>Kontaktdaten</title>
                        </MagnifyIcon>
                        <span>
                          <a href={contactDetails.kontaktdaten}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {contactDetails.kontaktdatenTitle}
                          </a>
                          <br />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <span></span>
      </section >
    );
  }
}

export default connect(store => {
  return {
    configStorage: store.configStorage,
    mandantStorage: store.mandantStorage
  };
})(SitecontactDetails);
